(function(){
  document.querySelectorAll('[data-av-archive]').forEach(function(root){
    var originalButtons=[].slice.call(root.querySelectorAll('[data-av-file]'));
    var tree=root.querySelector('.av-archive__tree');
    var preview=root.querySelector('[data-av-preview]');
    var title=root.querySelector('[data-av-view-title]');
    var type=root.querySelector('[data-av-view-type]');
    var cmd=root.querySelector('[data-av-command]');
    var clock=root.querySelector('[data-av-archive-clock]');
    var unlockedFolders={};

    function showArchiveWarning(){
      if(!root || root.dataset.avWarningShown === 'true') return;
      root.dataset.avWarningShown='true';
      var warning=document.createElement('div');
      warning.className='av-archive-warning';
      warning.setAttribute('role','dialog');
      warning.setAttribute('aria-modal','true');
      warning.innerHTML=''+
        '<div class="av-archive-warning__box">'+
          '<div class="av-archive-warning__title">warning</div>'+
          '<div class="av-archive-warning__copy">'+
            '<p>you are about to access an unprotected archive.</p>'+
            '<p>recovered files may be incomplete, damaged, or psychologically distressing.</p>'+
          '</div>'+
          '<div class="av-archive-warning__actions">'+
            '<button type="button" data-av-warning-continue>[ continue ]</button>'+
            '<button type="button" data-av-warning-return>[ return ]</button>'+
          '</div>'+
        '</div>';
      root.appendChild(warning);
      var cont=warning.querySelector('[data-av-warning-continue]');
      var ret=warning.querySelector('[data-av-warning-return]');
      function close(){
        warning.classList.add('is-leaving');
        setTimeout(function(){ warning.remove(); },260);
      }
      cont.addEventListener('click', close);
      ret.addEventListener('click', function(){
        if(document.referrer && document.referrer !== window.location.href){ history.back(); }
        else { window.location.href='/'; }
      });
      warning.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
      setTimeout(function(){ cont.focus(); },60);
    }

    function esc(s){return String(s||'').replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
    function textToHtml(s){return esc(s).replace(/\n/g,'<br>')}
    function kindLabel(kind){return String(kind||'note_file').replace('_file','').toUpperCase()}

    function buildFolders(){
      if(!tree || originalButtons.length < 2) return;
      var path=tree.querySelector('.av-archive__path');
      var up=tree.querySelector('.av-archive__folder');
      var count=tree.querySelector('.av-archive__count');
      var groups={};
      originalButtons.forEach(function(btn){
        var folder=(btn.dataset.fileFolder||'root').trim()||'root';
        if(!groups[folder]) groups[folder]=[];
        groups[folder].push(btn);
      });
      originalButtons.forEach(function(btn){btn.remove();});
      Object.keys(groups).forEach(function(folder){
        var wrap=document.createElement('div');
        wrap.className='av-archive__folder-group is-open';
        wrap.dataset.folderName=folder;
        var first=groups[folder][0];
        var pass=first.dataset.filePassword||'';
        var head=document.createElement('button');
        head.type='button';
        head.className='av-archive__folder-toggle';
        head.innerHTML='<span>▾</span> '+esc(folder)+(pass && !unlockedFolders[folder]?' <em>locked</em>':'');
        var files=document.createElement('div');
        files.className='av-archive__folder-files';
        groups[folder].forEach(function(btn){files.appendChild(btn);});
        head.addEventListener('click',function(){
          if(pass && !unlockedFolders[folder]){
            renderLocked(folder, pass, first.dataset.fileLockedLabel||'access level insufficient', function(){
              unlockedFolders[folder]=true;
              head.innerHTML='<span>▾</span> '+esc(folder);
              wrap.classList.add('is-open');
              var firstFile=files.querySelector('[data-av-file]');
              if(firstFile) render(firstFile);
            });
            return;
          }
          wrap.classList.toggle('is-open');
          head.querySelector('span').textContent=wrap.classList.contains('is-open')?'▾':'▸';
        });
        wrap.appendChild(head);wrap.appendChild(files);
        tree.insertBefore(wrap,count);
      });
    }

    function renderLocked(folder, pass, label, onUnlock){
      title.textContent=folder;
      type.textContent='LOCKED';
      cmd.textContent='unlock '+folder;
      preview.innerHTML='<div class="av-archive-lock"><div>'+esc(label)+'</div><label>password</label><div class="av-archive-lock__row"><input type="password" autocomplete="off"><button type="button">unlock</button></div><p class="av-archive-lock__error" hidden>incorrect</p></div>';
      var input=preview.querySelector('input');
      var button=preview.querySelector('button');
      function tryUnlock(){
        if(input.value===pass){
          if(onUnlock) onUnlock();
          return;
        }
        else { var err=preview.querySelector('.av-archive-lock__error'); err.hidden=false; input.value=''; input.focus(); }
      }
      button.addEventListener('click',tryUnlock);
      input.addEventListener('keydown',function(e){if(e.key==='Enter') tryUnlock();});
      input.focus();
    }

    function makeAudio(btn, t, meta, txt, audio){
      var cover=btn.dataset.fileCover||'';
      var disc=btn.dataset.fileDisc||'';
      var hasCover=cover?'<img class="av-archive-player__cover" src="'+esc(cover)+'" alt="" draggable="false">':'';
      var discInner=disc?'<img src="'+esc(disc)+'" alt="" draggable="false">':'';
      preview.innerHTML='<div class="av-archive-player" data-av-custom-audio>'+
        '<h2>'+esc(t)+'</h2>'+
        '<div class="av-archive-player__object">'+hasCover+'<div class="av-archive-player__disc">'+discInner+'</div></div>'+
        '<div class="av-archive-player__bar"><span></span></div>'+
        '<div class="av-archive-player__controls"><button type="button" data-av-play>[ play ]</button></div>'+
        '<p class="av-archive-player__time"><span data-av-current>0:00</span> / <span data-av-duration>'+esc(meta||'--:--')+'</span></p>'+
        '<div class="av-note">'+textToHtml(txt)+'</div>'+
        (audio?'<audio preload="metadata" controlslist="nodownload noplaybackrate" src="'+esc(audio)+'"></audio>':'<p class="av-note">Upload an MP3 to Shopify Files and paste the URL into this block.</p>')+
        '</div>';
      var player=preview.querySelector('[data-av-custom-audio]');
      var a=player.querySelector('audio');
      var play=player.querySelector('[data-av-play]');
      var bar=player.querySelector('.av-archive-player__bar');
      var fill=bar.querySelector('span');
      var cur=player.querySelector('[data-av-current]');
      var dur=player.querySelector('[data-av-duration]');
      function fmt(n){ if(!isFinite(n)) return '0:00'; var m=Math.floor(n/60), s=Math.floor(n%60); return m+':'+(s<10?'0':'')+s; }
      if(a){
        a.addEventListener('contextmenu',function(e){e.preventDefault();});
        a.addEventListener('loadedmetadata',function(){dur.textContent=fmt(a.duration);});
        a.addEventListener('timeupdate',function(){ var pct=a.duration?(a.currentTime/a.duration)*100:0; fill.style.width=pct+'%'; cur.textContent=fmt(a.currentTime); });
        a.addEventListener('play',function(){player.classList.add('is-playing'); play.textContent='[ pause ]';});
        a.addEventListener('pause',function(){player.classList.remove('is-playing'); play.textContent='[ play ]';});
        a.addEventListener('ended',function(){player.classList.remove('is-playing'); play.textContent='[ play ]';});
        play.addEventListener('click',function(){ a.paused?a.play():a.pause(); });
        bar.addEventListener('click',function(e){ var r=bar.getBoundingClientRect(); if(a.duration) a.currentTime=((e.clientX-r.left)/r.width)*a.duration; });
      }
    }

    function render(btn){
      var folder=(btn.dataset.fileFolder||'root').trim()||'root';
      var pass=btn.dataset.filePassword||'';
      if(pass && !unlockedFolders[folder]){
        renderLocked(folder,pass,btn.dataset.fileLockedLabel||'access level insufficient',function(){
          unlockedFolders[folder]=true;
          var group=root.querySelector('[data-folder-name="'+CSS.escape(folder)+'"]');
          if(group){
            var h=group.querySelector('.av-archive__folder-toggle');
            if(h) h.innerHTML='<span>▾</span> '+esc(folder);
            group.classList.add('is-open');
            var caret=group.querySelector('.av-archive__folder-toggle span');
            if(caret) caret.textContent='▾';
          }
          render(btn);
        });
        return;
      }
      originalButtons.forEach(function(b){b.classList.toggle('is-active',b===btn)});
      var t=btn.dataset.fileTitle||'unknown';
      var kind=btn.dataset.fileType||'note_file';
      var meta=btn.dataset.fileMeta||'';
      var txt=btn.dataset.fileText||'';
      title.textContent=t; type.textContent=kindLabel(kind); cmd.textContent='open '+t;
      if(kind==='audio_file'){
        makeAudio(btn,t,meta,txt,btn.dataset.fileAudio||'');
      }else if(kind==='image_file'){
        var img=btn.dataset.fileImage||'';
        preview.innerHTML='<div class="av-image-preview">'+(img?'<img src="'+esc(img)+'" alt="'+esc(t)+'" loading="lazy" draggable="false">':'<div class="av-note">No image selected yet.</div>')+'<div class="av-note">'+textToHtml(txt)+'</div></div>';
        preview.querySelectorAll('img').forEach(function(im){im.addEventListener('contextmenu',function(e){e.preventDefault();}); im.addEventListener('dragstart',function(e){e.preventDefault();});});
      }else{
        preview.innerHTML='<div class="av-note">'+textToHtml(txt)+'</div>';
      }
    }

    showArchiveWarning();
    buildFolders();
    originalButtons.forEach(function(b){b.addEventListener('click',function(){render(b)})});
    if(originalButtons[0]) render(originalButtons[0]);
    setInterval(function(){if(clock){var d=new Date();clock.textContent=d.toLocaleTimeString([], {hour12:false});}},1000);
  });
})();
